import {
    Box,
    Flex,
    HStack,
    InputGroup,
    Input,
    InputLeftElement,
    Text,
    VStack,
} from "@chakra-ui/react";
import React from "react";
import { RiSearch2Fill } from "react-icons/ri";
import { useSelector } from "react-redux";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";

const SearchBar = ({ phone, setPhone, videoName, setVideoName }) => {
    const count = useSelector((state) => state.videos.userVideos?.length || 0);

    return (
        <VStack w="100%" my="30px">
            <Flex alignItems="center" w="100%" justifyContent="space-between">
                <Text fontSize="24px" fontWeight="600" color="main_1">
                    مشاهدات الفيديوهات
                </Text>

                <Flex alignItems="center">
                    <LogoutMenu />
                </Flex>
            </Flex>
            
            <Flex w="100%" alignItems="center" justifyContent="space-between">
                <Text w="100%" fontSize="20px" textAlign="right">
                    عدد الفيديوهات: {count}
                </Text>
                
                <HStack spacing={4}>
                    <InputGroup maxW="300px">
                        <InputLeftElement pointerEvents="none">
                            <RiSearch2Fill color="gray.300" />
                        </InputLeftElement>
                        <Input
                            placeholder="البحث برقم الهاتف..."
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            borderRadius="16px"
                            border="1px solid"
                            borderColor="gray.300"
                            _focus={{
                                borderColor: "main_1",
                                boxShadow: "0 0 0 1px var(--chakra-colors-main_1)",
                            }}
                        />
                    </InputGroup>
                    
                    <InputGroup maxW="300px">
                        <InputLeftElement pointerEvents="none">
                            <RiSearch2Fill color="gray.300" />
                        </InputLeftElement>
                        <Input
                            placeholder="البحث باسم الفيديو..."
                            value={videoName}
                            onChange={(e) => setVideoName(e.target.value)}
                            borderRadius="16px"
                            border="1px solid"
                            borderColor="gray.300"
                            _focus={{
                                borderColor: "main_1",
                                boxShadow: "0 0 0 1px var(--chakra-colors-main_1)",
                            }}
                        />
                    </InputGroup>
                </HStack>
            </Flex>
        </VStack>
    );
};

export default SearchBar; 